module.exports = __webpack_public_path__ + "static/media/PK.bef759db.svg";